module.exports = __webpack_public_path__ + "static/oghma-symbol-DND3_FnP-3e7ac6dc4dc18e173a52e884fa74f7d5.webp";